module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p8-2098f60fab25a97663a352a2814abfe9.png";